import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import ReactGA from 'react-ga';
import { translate } from 'react-i18next';
import { parse } from 'qs';
import { withRouter } from 'react-router-dom';

class Landing extends Component {
  componentWillMount() {
    const { location, t } = this.props;
    const query = parse(location.search);
    const skipLanding = t('config.skip_landing');

    // if it's CVL only we need to pass the user to the main app
    // and don't show them the landing page
    if (skipLanding || query.cvl === 'true') {
      this.showMainApp();
    }
  }

  componentDidMount() {
    ReactGA.pageview('landing');
  }

  handleClick = () => {
    ReactGA.event({ category: this.props.i18n.language, action: 'B2B' });
    this.showMainApp();
  };

  showMainApp = () => {
    const showMainApp = true;
    this.props.showMainApp({ showMainApp });
  };

  render() {
    const type = parse(window.location.search.replace('?', '')).type;
    const { t } = this.props;
    const url = t('landing.buttons.car_owner_url_' + type);
    const copy = t('landing.buttons.car_owner_' + type);
    const target = type === 'lcw' ? 'selector' : '_parent';

    return (
      <I18n ns="translations">
        {(t) => (
          <section className="landing">
            <div className="container">
              <img src="images/logo.png" alt="logo" />
              <h1>{t('landing.title')}</h1>
              <div className="inner-content">
                <p>{t('landing.copy')}</p>
                <a className="button" onClick={this.handleClick}>
                  {t('landing.buttons.professional')}
                </a>
                <a
                  className="button"
                  onClick={() =>
                    ReactGA.event({ category: this.props.i18n.language, action: 'B2C' })
                  }
                  href={url}
                  target={target}
                >
                  {copy}
                </a>
              </div>
            </div>
          </section>
        )}
      </I18n>
    );
  }
}

export default withRouter(translate('translations')(Landing));



// WEBPACK FOOTER //
// ./src/components/landing.js